import { ScanFace } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ScanFaceIcon = createLucideIcon(ScanFace);
